import React from "react";
import { NavLink } from "react-router-dom";
import { Sheet, SheetContent } from "../ui/sheet";
import { NAV } from "./Sidebar";
import { BrandLogo } from "./BrandLogo";

// Mobile main menu: the desktop sidebar routes inside a left drawer, opened from the top-bar hamburger.
export default function MobileNav({ open, onOpenChange, badges = {} }) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="left" className="w-[280px] p-0 bg-panel border-border flex flex-col" data-testid="mobile-nav">
        <div className="h-14 px-4 flex items-center border-b border-border"><BrandLogo className="h-8" /></div>
        <nav className="flex-1 overflow-y-auto scrollbar-none py-2">
          {NAV.map((n) => {
            const Icon = n.icon;
            const b = badges[n.id];
            return (
              <NavLink key={n.id} to={n.to} data-testid={`mnav-${n.id}`} onClick={() => onOpenChange(false)}
                className={({ isActive }) => `mx-2 my-0.5 px-3 h-11 rounded-lg flex items-center gap-3 text-sm font-medium ${isActive ? "bg-primary/15 text-primary" : "text-muted-foreground hover:bg-secondary hover:text-foreground"}`}>
                <Icon className="h-[18px] w-[18px]" />
                <span>{n.label}</span>
                {b?.count > 0 && <span className={`ml-auto min-w-[18px] h-[18px] px-1 rounded-full text-[10px] font-bold flex items-center justify-center ${b.tone === "sell" ? "bg-sell text-white" : b.tone === "buy" ? "bg-buy text-black" : "bg-primary text-primary-foreground"}`}>{b.count > 99 ? "99+" : b.count}</span>}
              </NavLink>
            );
          })}
        </nav>
        <div className="px-4 py-3 border-t border-border text-[9px] font-bold text-primary tracking-widest">DISCIPLINE · EXECUTION · FREEDOM</div>
      </SheetContent>
    </Sheet>
  );
}
